// const serverUrl = 'http://114.132.162.224:2000';
// const serverUrl = 'http://www.richget.cc';
const serverUrl = 'http://qtsa.114kaili.com:2000';
const serverUrl2 = 'https://ych.114kaili.com:300';
const costkey = '4C8FBE350D8B679E4C8FBE350D8B679E';

export default {
    serverUrl,
    serverUrl2,
    costkey,
    isMobile() {
        return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    }
}



// WEBPACK FOOTER //
// ./src/commons/Config.js